import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/mobile/share-link-img.svg'
import _imports_1 from '@/assets/images/mobile/icon_lightning.svg'
import _imports_2 from '@/assets/images/mobile/icon_lock.svg'
import _imports_3 from '@/assets/images/mobile/check-icon-share-link.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "mt-3 dashed-image",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_2 = { class: "d-flex justify-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "m-0 ms-1" }
const _hoisted_5 = { class: "d-flex justify-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_7 = { class: "m-0 ms-1" }
const _hoisted_8 = { class: "d-flex justify-items-center align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "check-icon-share-link",
  alt: ""
}, null, -1)
const _hoisted_10 = { class: "m-0 ms-1" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "m-0 ms-1 text-white pt-1" }
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_tips = _resolveComponent("error-tips")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: _normalizeClass(["features d-flex gap-2 mt-3", [_ctx.$route.query.lang?.toString().toLowerCase() == 'en'?'flex-column':'']])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("p", _hoisted_4, _toDisplayString($setup.local.share_link_6), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("p", _hoisted_7, _toDisplayString($setup.local.share_link_7), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("p", _hoisted_10, _toDisplayString($setup.local.share_link_8), 1)
      ])
    ], 2),
    _createElementVNode("a", {
      class: "download-android d-flex mt-3 p-2 justify-content-center align-items-center rounded-5",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.downloadFile())),
      role: "button"
    }, [
      _createElementVNode("img", {
        src: $setup.data.clientOSImage,
        width: "32",
        alt: "cleint"
      }, null, 8, _hoisted_11),
      _createElementVNode("p", _hoisted_12, _toDisplayString($setup.data.clientOS), 1)
    ]),
    _createElementVNode("a", {
      class: "go-to-website mt-3 text-center",
      href: $setup.websiteHost
    }, _toDisplayString($setup.local.share_link_10), 9, _hoisted_13),
    _createVNode(_component_error_tips, { ref: "errorRef" }, null, 512)
  ], 64))
}